import { Component, EventEmitter, Inject, Output } from '@angular/core';
import { FormBuilder } from '@angular/forms';
import { HelpersService } from '../../../../core/services/helpers.service';
import { OperationsService } from '../../../../core/services/operations.service';
import { IncassoForm } from '../../../form/incasso-form';
import { SezioneIncassiResponse } from '../../../models/dto/sezione-incassi-response';
import { FascicoloFull } from '../../../models/fascicolo/fascicolo-full';
import { Incasso } from '../../../models/incasso';
import { SezioneIncassi } from '../../../models/sezioni/sezione-incassi';

@Component({
    selector: 'div [incasso-form-add]',
  templateUrl: '../../../form/incasso-form.html'
})

export class IncassiAddComponent extends IncassoForm {
  private idSezione: string;
  private idFascicolo: string;
  private urlInsert: string;
  private urlReadSezioneControparti: string;

  @Output() onReturn: EventEmitter<SezioneIncassi> = new EventEmitter<SezioneIncassi>();

  constructor(@Inject(OperationsService) operationService, @Inject(FormBuilder) campiForm, @Inject(HelpersService) helpers: HelpersService) {
        super(operationService, campiForm, helpers);
  }

  ngOnInit() {
    this.setTitle('Aggiungi Incasso');
    this.isInserimento(true);
  }

  getIncasso() {
    return new Incasso();
  }

  getUrlReadSezioneControparti() {
    return this.urlReadSezioneControparti;
  }

  getRequest(request: Incasso) {
    this.operationService.addIncasso(this.urlInsert, request, this.idSezione, this.idFascicolo).subscribe((response: any) => this.datiIncasso(response));
  }

  datiIncasso(response: SezioneIncassiResponse) {
    if (response.returnCode === 'OK') {
      this.onReturn.emit(response.sezione);
    }
  }

  inizializza(idSezione: string, idFascicolo: string, idSezioneControparti: string, urlInsert: string, urlReadSezioneControparti: string, fascicolo: FascicoloFull) {
    this.idSezione = idSezione;
    this.fascicolo = fascicolo;
    this.idFascicolo = idFascicolo;
    this.urlInsert = urlInsert;
    this.urlReadSezioneControparti = urlReadSezioneControparti;
    if (idSezioneControparti) {
      this.readSezioneControparti(idSezioneControparti);
    }
    this.createForm();
    this.populateSelect();
  }

}
